import {
  AngelusPetLogo,
  SkeletonHeaderHome,
} from '@angeplus/prever-component-lib';
import dynamic from 'next/dynamic';
import { ReactNode } from 'react';

const HeaderHomeNotificationDynamic = dynamic<{ image: ReactNode }>(
  () => import('notification/HeaderHomeNotification'),
  { loading: () => <SkeletonHeaderHome /> },
);

export const HeaderHome = () => (
  <HeaderHomeNotificationDynamic image={<AngelusPetLogo />} />
);
